export const events = [
  {
    title: "Holy Qurbana",
    date: "2025-10-04",
    time: "9am",
    description: "Followed by Half Yearly GBM and MMVS Happy Feet Walkers",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana & Harvest Festival",
    date: "2025-10-19",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Feast of St. Gregorios of Parumala",
    date: "2025-11-01",
    time: "9am",
    description: "Parumala Perunnal followed by Food Festival",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2025-11-16",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana & Christmas Carols",
    date: "2025-12-06",
    time: "9am",
    description: "Sunday School Children's Day",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Christmas Carols",
    date: "2025-12-06",
    time: "9am",
    description: "Day 1",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Christmas Carols",
    date: "2025-12-13",
    time: "9am",
    description: "Day 2",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2025-12-21",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Christmas",
    date: "2025-12-24",
    time: "TBC",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-01-03",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-01-18",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Fast of Nineveh",
    date: "2026-02-04",
    time: "6:30pm",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana & Sunday School Annual Day",
    date: "2026-02-07",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-02-15",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-03-07",
    time: "9am",
    description: "Followed by MMVS Church Trivia in celebration of International Women's Day",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Mid Lent Holy Qurbana",
    date: "2026-03-10",
    time: "6:30pm",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-03-15",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Feast of Annunciation to St. Mary",
    date: "2026-03-24",
    time: "6:30pm",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "40th Friday of Great Lent",
    date: "2026-03-26",
    time: "6:30pm",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Palm Sunday",
    date: "2026-03-29",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Pesaha Perunnal",
    date: "2026-04-01",
    time: "6:30pm",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Good Friday",
    date: "2026-04-03",
    time: "TBC",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Saturday",
    date: "2026-04-04",
    time: "TBC",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Easter",
    date: "2026-04-04",
    time: "TBC",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-04-19",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-05-02",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-05-17",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-06-06",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-06-21",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-07-04",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-07-19",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-08-01",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-08-16",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-09-05",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-09-20",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-10-03",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-10-18",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-11-07",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-11-15",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-12-05",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
  {
    title: "Holy Qurbana",
    date: "2026-12-20",
    time: "9am",
    description: "",
    location: (
      <>
        St. Cecilia R.C. Church <br />
        Ryhope Road
        <br /> Sunderland
        <br />
        SR2 7TG
      </>
    ),
  },
];
